/**
 * normalizeWoStatus — Maps legacy/variant WO status strings to the canonical
 * two-state vocabulary per §2: Active | Completed.
 *
 * Legacy values that map to "Active":
 *   - "Pending", "pending"
 *   - "Scheduled", "scheduled"
 *   - "In Progress", "in_progress", "in progress"
 *   - "Not scheduled", "not_scheduled"
 *   - "active"
 *
 * Only "completed" / "Completed" maps to "Completed".
 * Everything else defaults to "Active".
 */
export function normalizeWoStatus(status) {
  if (!status) return 'Active';
  const lower = String(status).toLowerCase().trim();
  if (lower === 'completed') return 'Completed';
  // All other states (pending, scheduled, in_progress, active, not_scheduled, etc.) → Active
  return 'Active';
}
